import {Injectable} from '@angular/core';

interface Component {
    initialised: boolean,
    data: any
}

@Injectable({
    providedIn: 'root'
})
export class StatePersistenceService {

    progress: boolean = false;
    orientation: string = '';
    expansion: string = '';
    headerCss: string = '';

    contactComponent: Component = {
        initialised: false,
        data: { }
    }

    quoteComponent: Component = {
        initialised: false,
        data: {
            items: []
        }
    }

    notFoundComponent: Component = {
        initialised: false,
        data: {
            items: []
        }
    }

    mainComponent: Component = {
        initialised: false,
        data: {
            items: []
        }
    }
}
